export const COPY = {
    STEPWISE_RESULT_NOT_FOUND_REGEX: /(Result not found, review _stepsTaken to see what happened\.)\s+(\[{.*}])/g,
    CHAT_DELETED_MESSAGE: (chatName?: string) =>
        `${
            chatName ? `{${chatName}} ` : ''
        } sohbeti başka bir kullanıcı tarafından silindi. Şu anda en son sohbet geçmişine erişebilirsiniz. Tüm sohbet içeriği yenilemek veya uygulamayı kapatmak ile temizlenir.`,
    REFRESH_APP_ADVISORY: 'Lütfen sayfayı yenileyerek en güncel verileri elde edin.',
};
